jQuery(document).ready(function() {
	window.scrollTo(0, 10);
	window.scrollTo(0, 0);
}); // javascript was made to save us


	jQuery(document).ready(function(){
	   jQuery('#ex1').zoom();
       var cnt= jQuery("#slide-gal li:nth-child(1) .img-cnt").attr('src');
       jQuery(".img-featured").attr('src',cnt);
       jQuery(".zoomImg").attr('src',cnt);
       jQuery(".zoomImg").css({
   'width' : '960px !important',
   'height' : '960px !important'
});
	});

jQuery(document).ready(function(){
  
  
  jQuery("#slide-gal li a").click(function(){
    var v=jQuery(this).data("src"); 
    jQuery(".img-featured").attr('src',v);
     jQuery(".zoomImg").attr('src',v);
   
  
  });

});

